module.exports = __webpack_public_path__ + "static/media/creative.green.gray.r.aba04601.png";